export default class User {
    constructor(
        id,
        firstName,
        lastName,
        email,
        userName,
        expiresIn,
        activated,
        organizationId,
        accessForAllSubOrgs
    ) {
        this.id = id
        this.firstName = firstName
        this.lastName = lastName
        this.email = email
        this.userName = userName
        this.expiresIn = expiresIn
        this.activated = activated
        this.organizationId = organizationId
        this.fullName = firstName + ' ' + lastName
        this.accessForAllSubOrgs = accessForAllSubOrgs
    }
}
